import { tokens } from "@blurb/codex-react";
import { Box } from "@mantine/core";
import React from "react";
import { RpiTableColumn } from "../RpiTable";
import { RpiTableHead } from "../RpiTableHead";
import { useRpiTableStyles } from "../RpiTableStyles";

export interface RpiTableEmptyStateProps {
  message?: string;
  columns: RpiTableColumn<any>[];
}
export const RpiTableEmptyState: React.FC<RpiTableEmptyStateProps> = ({ message, columns }) => {
  const { classes, cx } = useRpiTableStyles({ variant: "normalV2" });

  return (
    <table className={cx(classes.table, classes.variant)}>
      <RpiTableHead columns={columns} variant="normalV2" />
      <tbody>
        <tr>
          <td colSpan={columns.length}>
            <EmptyMessage message={message} />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

interface EmptyMessageProps {
  message?: string;
}

const EmptyMessage: React.FC<EmptyMessageProps> = ({ message = "No data found." }) => {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: tokens.color.semantic.bg.surface,
        padding: tokens.spacing[6],
        fontFamily: tokens.font.family.sans,
        fontSize: tokens.font.size.sm,
        "font-weight": tokens.font.weight.normal,
        color: tokens.color.semantic.text.subtle,
      }}
    >
      {message}
    </Box>
  );
};
